import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _479f0f3d = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _4c258667 = () => interopDefault(import('..\\pages\\aboutUs\\index.vue' /* webpackChunkName: "pages/aboutUs/index" */))
const _512ec688 = () => interopDefault(import('..\\pages\\applicationIntroduction\\index.vue' /* webpackChunkName: "pages/applicationIntroduction/index" */))
const _0cc36352 = () => interopDefault(import('..\\pages\\case\\index.vue' /* webpackChunkName: "pages/case/index" */))
const _415c4e8b = () => interopDefault(import('..\\pages\\coreTechnology.vue' /* webpackChunkName: "pages/coreTechnology" */))
const _6756ea02 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _77d9818e = () => interopDefault(import('..\\pages\\esg\\index.vue' /* webpackChunkName: "pages/esg/index" */))
const _71d1076a = () => interopDefault(import('..\\pages\\financialReport2022.vue' /* webpackChunkName: "pages/financialReport2022" */))
const _6f34d02a = () => interopDefault(import('..\\pages\\join.vue' /* webpackChunkName: "pages/join" */))
const _1905801a = () => interopDefault(import('..\\pages\\joinUs\\index.vue' /* webpackChunkName: "pages/joinUs/index" */))
const _e98427f0 = () => interopDefault(import('..\\pages\\klyr\\index.vue' /* webpackChunkName: "pages/klyr/index" */))
const _d3298062 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _61922ece = () => interopDefault(import('..\\pages\\news0105.vue' /* webpackChunkName: "pages/news0105" */))
const _39035f1b = () => interopDefault(import('..\\pages\\news0305.vue' /* webpackChunkName: "pages/news0305" */))
const _49d50e18 = () => interopDefault(import('..\\pages\\platformNewsCq.vue' /* webpackChunkName: "pages/platformNewsCq" */))
const _7f8c4aa8 = () => interopDefault(import('..\\pages\\pressCenter.vue' /* webpackChunkName: "pages/pressCenter" */))
const _355ab89a = () => interopDefault(import('..\\pages\\productB.vue' /* webpackChunkName: "pages/productB" */))
const _353e8998 = () => interopDefault(import('..\\pages\\productC.vue' /* webpackChunkName: "pages/productC" */))
const _34cdcd90 = () => interopDefault(import('..\\pages\\productG.vue' /* webpackChunkName: "pages/productG" */))
const _e9877414 = () => interopDefault(import('..\\pages\\technology\\index.vue' /* webpackChunkName: "pages/technology/index" */))
const _cbefa8f4 = () => interopDefault(import('..\\pages\\aboutUs\\001.vue' /* webpackChunkName: "pages/aboutUs/001" */))
const _cbd379f2 = () => interopDefault(import('..\\pages\\aboutUs\\002.vue' /* webpackChunkName: "pages/aboutUs/002" */))
const _cbb74af0 = () => interopDefault(import('..\\pages\\aboutUs\\003.vue' /* webpackChunkName: "pages/aboutUs/003" */))
const _264b5ba6 = () => interopDefault(import('..\\pages\\applicationIntroduction\\b-end.vue' /* webpackChunkName: "pages/applicationIntroduction/b-end" */))
const _8ae06ab2 = () => interopDefault(import('..\\pages\\applicationIntroduction\\c-end.vue' /* webpackChunkName: "pages/applicationIntroduction/c-end" */))
const _0ba186ab = () => interopDefault(import('..\\pages\\applicationIntroduction\\g-end.vue' /* webpackChunkName: "pages/applicationIntroduction/g-end" */))
const _10173d64 = () => interopDefault(import('..\\pages\\case\\cnpc.vue' /* webpackChunkName: "pages/case/cnpc" */))
const _58d80f90 = () => interopDefault(import('..\\pages\\case\\klsz.vue' /* webpackChunkName: "pages/case/klsz" */))
const _7b7a239e = () => interopDefault(import('..\\pages\\case\\ningbo.vue' /* webpackChunkName: "pages/case/ningbo" */))
const _841e140e = () => interopDefault(import('..\\pages\\joinUs\\001.vue' /* webpackChunkName: "pages/joinUs/001" */))
const _8401e50c = () => interopDefault(import('..\\pages\\joinUs\\002.vue' /* webpackChunkName: "pages/joinUs/002" */))
const _83e5b60a = () => interopDefault(import('..\\pages\\joinUs\\003.vue' /* webpackChunkName: "pages/joinUs/003" */))
const _8961ac24 = () => interopDefault(import('..\\pages\\news\\icbc.vue' /* webpackChunkName: "pages/news/icbc" */))
const _f51fcfca = () => interopDefault(import('..\\pages\\news\\klsz.vue' /* webpackChunkName: "pages/news/klsz" */))
const _e1872066 = () => interopDefault(import('..\\pages\\news\\klyr.vue' /* webpackChunkName: "pages/news/klyr" */))
const _c042890c = () => interopDefault(import('..\\pages\\news\\klyr20250617.vue' /* webpackChunkName: "pages/news/klyr20250617" */))
const _bf27d32e = () => interopDefault(import('..\\pages\\technology\\arcturus.vue' /* webpackChunkName: "pages/technology/arcturus" */))
const _734fc3b3 = () => interopDefault(import('..\\pages\\technology\\canopus.vue' /* webpackChunkName: "pages/technology/canopus" */))
const _bc10dc4e = () => interopDefault(import('..\\pages\\technology\\cloud.vue' /* webpackChunkName: "pages/technology/cloud" */))
const _79cf89b4 = () => interopDefault(import('..\\pages\\technology\\procyon.vue' /* webpackChunkName: "pages/technology/procyon" */))
const _5847e45b = () => interopDefault(import('..\\pages\\technology\\rigel.vue' /* webpackChunkName: "pages/technology/rigel" */))
const _024b3177 = () => interopDefault(import('..\\pages\\technology\\sirius.vue' /* webpackChunkName: "pages/technology/sirius" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _479f0f3d,
    name: "about___zh"
  }, {
    path: "/aboutUs",
    component: _4c258667,
    name: "aboutUs___zh"
  }, {
    path: "/applicationIntroduction",
    component: _512ec688,
    name: "applicationIntroduction___zh"
  }, {
    path: "/case",
    component: _0cc36352,
    name: "case___zh"
  }, {
    path: "/coreTechnology",
    component: _415c4e8b,
    name: "coreTechnology___zh"
  }, {
    path: "/en",
    component: _6756ea02,
    name: "index___en"
  }, {
    path: "/esg",
    component: _77d9818e,
    name: "esg___zh"
  }, {
    path: "/financialReport2022",
    component: _71d1076a,
    name: "financialReport2022___zh"
  }, {
    path: "/join",
    component: _6f34d02a,
    name: "join___zh"
  }, {
    path: "/joinUs",
    component: _1905801a,
    name: "joinUs___zh"
  }, {
    path: "/klyr",
    component: _e98427f0,
    name: "klyr___zh"
  }, {
    path: "/news",
    component: _d3298062,
    name: "news___zh"
  }, {
    path: "/news0105",
    component: _61922ece,
    name: "news0105___zh"
  }, {
    path: "/news0305",
    component: _39035f1b,
    name: "news0305___zh"
  }, {
    path: "/platformNewsCq",
    component: _49d50e18,
    name: "platformNewsCq___zh"
  }, {
    path: "/pressCenter",
    component: _7f8c4aa8,
    name: "pressCenter___zh"
  }, {
    path: "/productB",
    component: _355ab89a,
    name: "productB___zh"
  }, {
    path: "/productC",
    component: _353e8998,
    name: "productC___zh"
  }, {
    path: "/productG",
    component: _34cdcd90,
    name: "productG___zh"
  }, {
    path: "/technology",
    component: _e9877414,
    name: "technology___zh"
  }, {
    path: "/aboutUs/001",
    component: _cbefa8f4,
    name: "aboutUs-001___zh"
  }, {
    path: "/aboutUs/002",
    component: _cbd379f2,
    name: "aboutUs-002___zh"
  }, {
    path: "/aboutUs/003",
    component: _cbb74af0,
    name: "aboutUs-003___zh"
  }, {
    path: "/applicationIntroduction/b-end",
    component: _264b5ba6,
    name: "applicationIntroduction-b-end___zh"
  }, {
    path: "/applicationIntroduction/c-end",
    component: _8ae06ab2,
    name: "applicationIntroduction-c-end___zh"
  }, {
    path: "/applicationIntroduction/g-end",
    component: _0ba186ab,
    name: "applicationIntroduction-g-end___zh"
  }, {
    path: "/case/cnpc",
    component: _10173d64,
    name: "case-cnpc___zh"
  }, {
    path: "/case/klsz",
    component: _58d80f90,
    name: "case-klsz___zh"
  }, {
    path: "/case/ningbo",
    component: _7b7a239e,
    name: "case-ningbo___zh"
  }, {
    path: "/en/about",
    component: _479f0f3d,
    name: "about___en"
  }, {
    path: "/en/aboutUs",
    component: _4c258667,
    name: "aboutUs___en"
  }, {
    path: "/en/applicationIntroduction",
    component: _512ec688,
    name: "applicationIntroduction___en"
  }, {
    path: "/en/case",
    component: _0cc36352,
    name: "case___en"
  }, {
    path: "/en/coreTechnology",
    component: _415c4e8b,
    name: "coreTechnology___en"
  }, {
    path: "/en/esg",
    component: _77d9818e,
    name: "esg___en"
  }, {
    path: "/en/financialReport2022",
    component: _71d1076a,
    name: "financialReport2022___en"
  }, {
    path: "/en/join",
    component: _6f34d02a,
    name: "join___en"
  }, {
    path: "/en/joinUs",
    component: _1905801a,
    name: "joinUs___en"
  }, {
    path: "/en/klyr",
    component: _e98427f0,
    name: "klyr___en"
  }, {
    path: "/en/news",
    component: _d3298062,
    name: "news___en"
  }, {
    path: "/en/news0105",
    component: _61922ece,
    name: "news0105___en"
  }, {
    path: "/en/news0305",
    component: _39035f1b,
    name: "news0305___en"
  }, {
    path: "/en/platformNewsCq",
    component: _49d50e18,
    name: "platformNewsCq___en"
  }, {
    path: "/en/pressCenter",
    component: _7f8c4aa8,
    name: "pressCenter___en"
  }, {
    path: "/en/productB",
    component: _355ab89a,
    name: "productB___en"
  }, {
    path: "/en/productC",
    component: _353e8998,
    name: "productC___en"
  }, {
    path: "/en/productG",
    component: _34cdcd90,
    name: "productG___en"
  }, {
    path: "/en/technology",
    component: _e9877414,
    name: "technology___en"
  }, {
    path: "/joinUs/001",
    component: _841e140e,
    name: "joinUs-001___zh"
  }, {
    path: "/joinUs/002",
    component: _8401e50c,
    name: "joinUs-002___zh"
  }, {
    path: "/joinUs/003",
    component: _83e5b60a,
    name: "joinUs-003___zh"
  }, {
    path: "/news/icbc",
    component: _8961ac24,
    name: "news-icbc___zh"
  }, {
    path: "/news/klsz",
    component: _f51fcfca,
    name: "news-klsz___zh"
  }, {
    path: "/news/klyr",
    component: _e1872066,
    name: "news-klyr___zh"
  }, {
    path: "/news/klyr20250617",
    component: _c042890c,
    name: "news-klyr20250617___zh"
  }, {
    path: "/technology/arcturus",
    component: _bf27d32e,
    name: "technology-arcturus___zh"
  }, {
    path: "/technology/canopus",
    component: _734fc3b3,
    name: "technology-canopus___zh"
  }, {
    path: "/technology/cloud",
    component: _bc10dc4e,
    name: "technology-cloud___zh"
  }, {
    path: "/technology/procyon",
    component: _79cf89b4,
    name: "technology-procyon___zh"
  }, {
    path: "/technology/rigel",
    component: _5847e45b,
    name: "technology-rigel___zh"
  }, {
    path: "/technology/sirius",
    component: _024b3177,
    name: "technology-sirius___zh"
  }, {
    path: "/en/aboutUs/001",
    component: _cbefa8f4,
    name: "aboutUs-001___en"
  }, {
    path: "/en/aboutUs/002",
    component: _cbd379f2,
    name: "aboutUs-002___en"
  }, {
    path: "/en/aboutUs/003",
    component: _cbb74af0,
    name: "aboutUs-003___en"
  }, {
    path: "/en/applicationIntroduction/b-end",
    component: _264b5ba6,
    name: "applicationIntroduction-b-end___en"
  }, {
    path: "/en/applicationIntroduction/c-end",
    component: _8ae06ab2,
    name: "applicationIntroduction-c-end___en"
  }, {
    path: "/en/applicationIntroduction/g-end",
    component: _0ba186ab,
    name: "applicationIntroduction-g-end___en"
  }, {
    path: "/en/case/cnpc",
    component: _10173d64,
    name: "case-cnpc___en"
  }, {
    path: "/en/case/klsz",
    component: _58d80f90,
    name: "case-klsz___en"
  }, {
    path: "/en/case/ningbo",
    component: _7b7a239e,
    name: "case-ningbo___en"
  }, {
    path: "/en/joinUs/001",
    component: _841e140e,
    name: "joinUs-001___en"
  }, {
    path: "/en/joinUs/002",
    component: _8401e50c,
    name: "joinUs-002___en"
  }, {
    path: "/en/joinUs/003",
    component: _83e5b60a,
    name: "joinUs-003___en"
  }, {
    path: "/en/news/icbc",
    component: _8961ac24,
    name: "news-icbc___en"
  }, {
    path: "/en/news/klsz",
    component: _f51fcfca,
    name: "news-klsz___en"
  }, {
    path: "/en/news/klyr",
    component: _e1872066,
    name: "news-klyr___en"
  }, {
    path: "/en/news/klyr20250617",
    component: _c042890c,
    name: "news-klyr20250617___en"
  }, {
    path: "/en/technology/arcturus",
    component: _bf27d32e,
    name: "technology-arcturus___en"
  }, {
    path: "/en/technology/canopus",
    component: _734fc3b3,
    name: "technology-canopus___en"
  }, {
    path: "/en/technology/cloud",
    component: _bc10dc4e,
    name: "technology-cloud___en"
  }, {
    path: "/en/technology/procyon",
    component: _79cf89b4,
    name: "technology-procyon___en"
  }, {
    path: "/en/technology/rigel",
    component: _5847e45b,
    name: "technology-rigel___en"
  }, {
    path: "/en/technology/sirius",
    component: _024b3177,
    name: "technology-sirius___en"
  }, {
    path: "/",
    component: _6756ea02,
    name: "index___zh"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
